import { safeFetch } from "../utils/safeFetch";
import { buildApiError } from "../utils/apiErrors";

// Multiple orders checkout API call. This is used in the "Checkout Multiple Orders" feature.

const readErrorMessage = async (response, fallback) => {
  if (response.status === 0) return "Impossibile connettersi al server";

  try {
    const payload = await response.json();
    return payload?.error || payload?.message || fallback;
  } catch (_) {
    const text = await response.text().catch(() => "");
    return text || fallback;
  }
};

export const checkoutMultipleOrders = async (payload, token, tenant) => {
  const response = await safeFetch(`/api/receipts/checkout-multiple`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw await buildApiError(response, `HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const checkoutOrderReceipt = async (payload, token, tenant) => {
  const response = await safeFetch(`/api/receipts/checkout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw await buildApiError(response, `HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const checkoutAllaRomana = async (payload, token, tenant) => {
  const response = await safeFetch('/api/receipts/checkout-alla-romana', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'x-tenant-id': tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw await buildApiError(response, `HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const getIssuedDocuments = async ({
  token,
  tenant,
  tab = "NORMAL",
  page = 1,
  limit = 25,
  from,
  to,
}) => {
  const params = new URLSearchParams();
  params.set("tab", tab);
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (from) params.set("from", new Date(`${from}T00:00:00`).toISOString());
  if (to) params.set("to", new Date(`${to}T23:59:59`).toISOString());

  const response = await safeFetch(`/api/receipts/issued-documents?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, `HTTP error! status: ${response.status}`));
  }

  return response.json();
};

export const getIssuedPrepaymentDocuments = async ({
  token,
  tenant,
  tab = "NORMAL",
  page = 1,
  limit = 25,
  from,
  to,
}) => {
  const params = new URLSearchParams();
  params.set("tab", tab);
  params.set("page", String(page));
  params.set("limit", String(limit));
  if (from) params.set("from", new Date(`${from}T00:00:00`).toISOString());
  if (to) params.set("to", new Date(`${to}T23:59:59`).toISOString());

  const response = await safeFetch(`/api/receipts/issued-documents/prepayments?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, `HTTP error! status: ${response.status}`));
  }

  return response.json();
};

const postReceiptAction = async (id, action, token, tenant) => {
  const response = await safeFetch(`/api/receipts/${id}/${action}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });
  if (!response.ok) {
    throw await buildApiError(response, `HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const voidIssuedReceipt = (id, token, tenant) => postReceiptAction(id, "void", token, tenant);
export const restoreVoidedReceipt = (id, token, tenant) => postReceiptAction(id, "restore", token, tenant);
export const restoreCongressReceipt = (id, token, tenant) => postReceiptAction(id, "restore-congress", token, tenant);
